import './NavBar.scss';
import {Button, Nav, Navbar, NavDropdown, Popover} from "react-bootstrap";
import React from "react";
import {useNavigate} from "react-router-dom";
import Avatar from "../Avatar";
import {handicaddieSelector} from "../../services/store/asyncThunk";
import HandicaddieLogo from "../../icons/HandicaddieLogo";
import useColourScheme, {ColourScheme} from "../../hooks/useColourScheme";
import SunFilledIcon from "../../icons/SunFilledIcon";
import {IconSize} from "../../services/IconConstants";
import SunIcon from "../../icons/SunIcon";

export interface Props {
    logOut?: () => void
    children?: React.ReactNode
}

export const NavigationBar = ({logOut, children}: Props) => {

    const navigate = useNavigate();

    const {colourScheme, setColourScheme} = useColourScheme();

    const { user } = handicaddieSelector((state) => state.session)

    const popover = (
        <Popover id="popover-basic">
            <Popover.Header as="h3">Email Us!</Popover.Header>
            <Popover.Body>
                We want to make sure you get the most out of Handicaddie,
                please feel free to reach out to help@handicaddie.com for assistance or feedback.
            </Popover.Body>
        </Popover>
    );

    const goToUserProfile = () => {
        if (!user) {
            return;
        }

        // navigate(buildUrl(MY_PROFILE));
    }

    const toggleTheme = () => {
        setColourScheme(colourScheme === ColourScheme.dark ? ColourScheme.light : ColourScheme.dark);
    }

    return (
        <Navbar className={"topnav"}>
            <Navbar.Brand>
                <HandicaddieLogo size={'md'} className={"navbar-hc-logo"} />
            </Navbar.Brand>

            <div className={"topnav-items-container"}>
                <Nav>
                    {children && children}
                </Nav>

                {user && logOut && <div className={"topnav-rhs-container"}>
                    <div onClick={toggleTheme}>
                        {colourScheme === ColourScheme.light && <SunFilledIcon size={IconSize.md} />}
                        {colourScheme === ColourScheme.dark && <SunIcon size={IconSize.md} />}
                    </div>
                    <NavDropdown id="accountOptions" title={<Button variant="outline-primary">
                             <Avatar size={'xs'} user={'current'} style={{marginRight: '1em'}}/>
                             {user?.displayName}
                         </Button>}>
                        <NavDropdown.Item onClick={logOut}>Log Out</NavDropdown.Item>
                    </NavDropdown>
                </div>
                }
            </div>
        </Navbar>
    );

}
